var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgendaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.18 30.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1d1d1b;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #ededed;\n      }\n\n      .cls-3 {\n        fill: #fe2215;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.09,
    cy: 15.09,
    r: 15.09
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.18,7.58h-.55v-.79c0-.2-.17-.37-.37-.37s-.37.17-.37.37v.79h-3.46v-.79c0-.2-.17-.37-.37-.37s-.37.17-.37.37v.79h-3.46v-.79c0-.2-.17-.37-.37-.37s-.37.17-.37.37v.79h-3.46v-.79c0-.2-.17-.37-.37-.37s-.37.17-.37.37v.79h-.97c-1.43,0-2.59,1.16-2.59,2.59v10.55c0,1.43,1.16,2.59,2.59,2.59h14.85c1.43,0,2.59-1.16,2.59-2.59v-10.55c0-1.43-1.16-2.59-2.59-2.59ZM7.33,8.33h.97v1.11c0,.2.17.37.37.37s.37-.17.37-.37v-1.11h3.46v1.11c0,.2.17.37.37.37s.37-.17.37-.37v-1.11h3.46v1.11c0,.2.17.37.37.37s.37-.17.37-.37v-1.11h3.46v1.11c0,.2.17.37.37.37s.37-.17.37-.37v-1.11h.55c1.02,0,1.85.83,1.85,1.85v1.39H5.48v-1.39c0-1.02.83-1.85,1.85-1.85ZM22.18,22.57H7.33c-1.02,0-1.85-.83-1.85-1.85v-8.42h18.55v8.42c0,1.02-.83,1.85-1.85,1.85Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 9.2,
    cy: 15.21,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 12.97,
    cy: 15.21,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 16.73,
    cy: 15.21,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 20.5,
    cy: 15.21,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 9.2,
    cy: 19.1,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 12.97,
    cy: 19.1,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 16.73,
    cy: 19.1,
    r: 1.32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendaIcon);
export default __webpack_public_path__ + "static/media/agenda-icon.79f5ae98dacede5d8354d33ad3234ee6.svg";
export { ForwardRef as ReactComponent };